import { useMutation, MutationResult } from '@apollo/client';
import {
  RefreshTimelineEntryMutation,
  RefreshTimelineEntryMutationVariables,
} from '../../../types/__generated__';
import mutation from './queries/refreshTimelineEntry.gql';

export function useRefreshTimelineEntry(
  timelineEntryId: string,
): [Function, MutationResult] {
  const [runMutation, mutationResult] = useMutation<
    RefreshTimelineEntryMutation,
    RefreshTimelineEntryMutationVariables
  >(mutation, {
    variables: { input: { id: timelineEntryId } },
    context: {
      credentials: 'include',
    },
    errorPolicy: 'all',
  });

  return [runMutation, mutationResult];
}
